import { LocalePrefix } from 'next-intl/routing';

export const defaultLocale = 'en' as const;
export const locales = ['en', 'ru', 'az'] as string[];

export const LOCALE: {
    locale: Record<string, Record<string, string>>;
} = {
    locale: {
        en: {
            key: 'az',
            label: 'AZ',
            image: '/svg/eng.svg',
        },
        az: {
            key: 'en',
            label: 'EN',
            image: '/svg/aze.svg',
        },
    },
};

export const localePrefix: LocalePrefix<typeof locales> = 'always';

export const port = process.env.PORT || 3000;
export const host = process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : `http://localhost:${port}`;

export const ITEMS_PER_PAGE = 16;
